export default {
      id: "calculator-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#calculator",
      toString: function () {
        return this.url;
      }
    }